import { Grid } from '@material-ui/core';
import jalaliMoment from 'jalali-moment';
import React from 'react';
import { connect } from 'react-redux';
import * as subordinateAction from './../../actions/subordinate';
import { IDENTITY_CONFIG } from "../../utils/authConst";
import avatar from "./../../assets/images/avatar_1.png";
import Img from 'react-image';



class SubordinateItem extends React.Component{
    constructor(props){
        super(props);
        this.state={
            color:this.props.Code.Color
        }
    }
    // componentDidMount = async () =>{
    //     const image =  await this.props.getSubordinateImages(this.props.ImageUrl)
    //     debugger;
    //     this.setState({image})
    //  }
    render = () => {
        const style={background:this.state.color}
        return(
            <div className="subordinate-item">
                
                <Grid container >
                    <Grid item xs={3} className="d-flex">
                    <Img alt=""  className="text-center mx-auto profile-image"
                                src={[(localStorage.getItem("subDomain")!==null ? IDENTITY_CONFIG.protocol+localStorage.getItem("subDomain")+"."+IDENTITY_CONFIG.baseUrl+this.props.ImageUrl:''),
                                    avatar]}
                            />
                     
                    </Grid>
                    <Grid item xs={5} className="d-flex">
                        <p className="my-auto font-weight-lighter text-gray" > {this.props.FullName} </p>
                    </Grid>
                    <Grid item xs={4}>
                        
                        <p className="text-center m-0" ><span style={style} className="badge d-inline-block">{this.props.Code.Name}</span></p>
                        <span className="d-block text-center h9 ">از ساعت {new jalaliMoment(this.props.AtendanceLogTime,"YYYY-MM-DDTHH:mm:ss.SSS Z").format("HH:mm")}</span>
                    </Grid>
                </Grid>
            </div>
        );
    
    }

}
const mapToStateProps = (state) => {
    return state;
}
export default connect(mapToStateProps,subordinateAction)(SubordinateItem)